import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { RegisterComponent } from './register';
import { AuthGuard } from './_guards';
import { UserComponent } from '@app/_components/user/user/user.component';
import { UserListComponent } from '@app/_components/user/user-list/user-list.component';
import { UserRoleComponent } from '@app/_components/user/user-role/user-role.component';
import { UserRoleListComponent } from '@app/_components/user/user-role-list/user-role-list.component';
import { UserResolver, UserRoleListResolver, MessageTemplateResolver, TaskResolver, AvailablePropertyFeaturesResolver, AvailableDevelopmentFeaturesResolver, PropertyResolver, ReservationResolver } from '@app/_resolvers';


import { PasswordResetComponent } from '@app/_components/user/password-reset/password-reset.component';
import { PasswordResetRequestComponent } from '@app/_components/user/password-reset-request/password-reset-request.component';
import { RateProfileComponent } from '@app/_components/rate/rate-profile/rate-profile/rate-profile.component';
import { RateProfileListComponent } from '@app/_components/rate/rate-profile/rate-profile-list/rate-profile-list.component';
import { RateManagerComponent } from '@app/_components/rate/rate-manager/rate-manager/rate-manager.component';
import { RateManagerListComponent } from '@app/_components/rate/rate-manager/rate-manager-list/rate-manager-list.component';
import { VacancyReportComponent } from './_components/report/reports/vacancy-report/vacancy-report.component';
import { TaskComponent } from '@app/_components/task/task/task.component';
import { TaskListComponent } from '@app/_components/task/task-list/task-list.component';
import { MaintenanceComponent } from './_components/task/impl/maintenance/maintenance/maintenance.component';
import { MaintenanceListComponent } from './_components/task/impl/maintenance/maintenance-list/maintenance-list.component';
import { PhoneComponent } from './_components/task/impl/phone/phone.component';

import { NoteComponent } from './_components/task/note/note/note.component';
import { MessageComponent } from '@app/_components/message/message/message.component';
import { MessageListComponent } from '@app/_components/message/message-list/message-list.component';
import { MessageTemplateComponent } from '@app/_components/message/message-template/message-template/message-template.component';
import { MessageTemplateListComponent } from '@app/_components/message/message-template/message-template-list/message-template-list.component';

import { PropertyComponent } from '@app/_components/property/property/property.component';
import { PropertyListComponent } from '@app/_components/property/property-list/property-list.component';
import { PropertyDeleteComponent } from '@app/_components/property/property-delete/property-delete.component';

import { DevelopmentComponent } from '@app/_components/development/development/development.component';
import { DevelopmentListComponent } from '@app/_components/development/development-list/development-list.component';

import { ReviewListComponent } from '@app/_components/review/components/review-list/review-list.component';


import { TagAddModalComponent } from '@app/_components/task/tag/tag-add-modal/tag-add-modal.component';
import { RateBucketComponent } from './_components/rate/rate-bucket/rate-bucket.component';
import { RateBucketDetailComponent } from './_components/rate/rate-bucket-detail/rate-bucket-detail.component';
import { CheckInOutReportComponent } from './_components/report/reports/check-in-out-report/check-in-out-report.component';
import { OwnerProfileComponent } from './_components/owner-profile/owner-profile/owner-profile.component';
import { OwnerProfileListComponent } from './_components/owner-profile/owner-profile-list/owner-profile-list.component';
import { GuestProfileComponent } from './_components/guest-profile/guest-profile/guest-profile.component';
import { GuestProfileListComponent } from './_components/guest-profile/guest-profile-list/guest-profile-list.component';
import { PropertyListResolver } from './_resolvers/property-list.resolver';
import { ReservationListComponent } from './_components/reservation/components/reservation-list/reservation-list.component';
import { ReservationComponent } from './_components/reservation/components/reservation/reservation.component';
import { RateSummaryComponent } from './_components/rate/rate-summary/rate-summary.component';
import { RentalsUnitedComponent } from './_components/rentals-united/rentals-united.component';
import { VRBOLogmanComponent } from './_components/vrbo_logman/vrbo-logman.component';
import { VRBOComponent } from './_components/vrbo/vrbo.component';
import { VRBOPromotionsDashboardComponent } from './_components/vrbo/components/vrbo-promotions-dashboard/vrbo-promotions-dashboard.component';
import { VRBOReviewsComponent } from './_components/vrbo/components/vrbo-reviews/vrbo-reviews.component';
import { GoogleComponent } from './_components/google/google.component';
import { GoogleLogmanComponent } from './_components/google_logman/google-logman.component';
import { LogmanListComponent } from './_components/logman/components/logman-list/logman-list.component';
import { LogmanComponent } from './_components/logman/components/logman/logman.component';
import { RateOverrideComponent } from './_components/rate/rate-override/rate-override.component';
import { ResRevReportComponent } from './_components/report/reports/res-rev-report/res-rev-report.component';
import { TestListComponent } from './_components/test/test-list/test-list.component';
import { ChannelListComponent } from './_components/channel/channel-list/channel-list.component';
import { GuestRefundListComponent } from './_components/guest-refund/guest-refund-list/guest-refund-list.component';
import { PropertyProfileListComponent } from './_components/property-profile/property-profile-list/property-profile-list.component';
import { CancellationPolicyViewComponent } from './_components/cancellation-policy/cancellation-policy-view/cancellation-policy-view.component';
import { FileUploadListComponent } from './_components/file-upload/file-upload-list/file-upload-list.component';
import { OrderProductListComponent } from './_components/order-product/order-product-list/order-product-list.component';
import { GuestMoveListComponent } from './_components/guest-move/guest-move-list/guest-move-list.component';
import { ActivityListComponent } from './_components/activity/activity-list/activity-list.component';
import { ActivityWishlistListComponent } from './_components/activity-wishlist/activity-wishlist-list/activity-wishlist-list.component';
import { ActivityWishlistComponent } from './_components/activity-wishlist/activity-wishlist/activity-wishlist.component';
import { ActivityFeeListComponent } from './_components/activity-fee/activity-fee-list/activity-fee-list.component';
import { ActivityScheduleListComponent } from './_components/activity-schedule/activity-schedule-list/activity-schedule-list.component';
import { ActivityProviderListComponent } from './_components/activity-provider/activity-provider-list/activity-provider-list.component';
import { ActivitiesManagerComponent } from './_components/activities-manager/activities-manager.component';
import { PersonListComponent } from './_components/person/person-list/person-list.component';
import { PersonAddressListComponent } from './_components/person-address/person-address-list/person-address-list.component';
import { PersonEmailListComponent } from './_components/person-email/person-email-list/person-email-list.component';
import { PersonPhoneListComponent } from './_components/person-phone/person-phone-list/person-phone-list.component';
import { PersonSocialListComponent } from './_components/person-social/person-social-list/person-social-list.component';
import { PictureListComponent } from './_components/picture/picture-list/picture-list.component';
import { ActivityComponent } from './_components/activity/activity/activity.component';
import { LostFoundListComponent } from './_components/lost-found/lost-found-list/lost-found-list.component';
import { RUDetailedLocationListComponent } from './_components/ru-detailed-location/ru-detailed-location-list/ru-detailed-location-list.component';
import { CostProfileListComponent } from './_components/cost-profile/cost-profile-list/cost-profile-list.component';
import { DailySummaryReportComponent } from './_components/report/reports/daily-summary-report/daily-summary-report.component';
import { ReportsDashboardComponent } from './_components/report/reports/reports-dashboard/reports-dashboard.component';
import { ResSalesReportComponent } from './_components/report/reports/res-sales-report/res-sales-report.component';
import { OccupancySummaryReportComponent } from './_components/report/reports/occupancy-summary-report/occupancy-summary-report.component';
import { FutureOccupancyReportComponent } from './_components/report/reports/future-occupancy-report/future-occupancy-report.component';
import { AnalyticsDashboardComponent } from './_components/report/reports/analytics-dashboard/analytics-dashboard.component';
import { QuoteAnalyticsComponent } from './_components/report/reports/quote-analytics/quote-analytics.component';
import { EscrowsReportComponent } from './_components/report/reports/escrows-report/escrows-report.component';
import { EscrowReportComponent } from './_components/report/reports/escrow-report/escrow-report.component';
import { EscrowReportAuditComponent } from './_components/report/reports/escrow-report-audit/escrow-report-audit.component';
import { EscrowPaymentMappingComponent } from './_components/report/reports/escrow-payment-mapping/escrow-payment-mapping.component';
import { ReservationSummaryReportComponent } from './_components/report/reports/reservation-summary-report/reservation-summary-report.component';
import { PaymentSummaryReportComponent } from './_components/report/reports/payment-summary-report/payment-summary-report.component';
import { GuestRefundReasonListComponent } from './_components/guest-refund-reason/guest-refund-reason-list/guest-refund-reason-list.component';
import { OwnerProfileGuestListComponent } from './_components/owner-profile-guest/owner-profile-guest-list/owner-profile-guest-list.component';
import { JobListComponent } from './_components/job/job-list/job-list.component';
import { ReservationLedgerListComponent } from './_components/reservation/components/reservation-ledger/reservation-ledger-list/reservation-ledger-list.component';
import { ListingQualityStatusListComponent } from './_components/listing-quality-status/listing-quality-status-list/listing-quality-status-list.component';
import { MsgCampaignListComponent } from './_components/msg-campaign/msg-campaign-list/msg-campaign-list.component';
import { MsgListComponent } from './_components/msg/msg-list/msg-list.component';
import { MsgRecipientListComponent } from './_components/msg-recipient/msg-recipient-list/msg-recipient-list.component';
import { QuestionAnswerListComponent } from './_components/question-answer/question-answer-list/question-answer-list.component';
import { FeaturesListComponent } from './_components/feature/feature-listing/feature-listing.component';
import { PropertyFeatureListComponent } from './_components/property/property-feature/property-feature-list/property-feature-list.component';
import { ReservationContainerComponent } from './_components/reservation/components/reservation/reservation-container/reservation-container.component';
import { CodeProjectListComponent } from './_components/code-project/code-project-list/code-project-list.component';
import { CodeTaskListComponent } from './_components/code-task/code-task-list/code-task-list.component';
import { PropertyFeatureTemplateListComponent } from './_components/property/property-feature-template/property-feature-template-list/property-feature-template-list.component';
import { GuestCampaignComponent } from './_components/guest-campaign/guest-campaign/guest-campaign.component';
import { PropertySummaryListComponent } from './_components/property/propery-summary-list/propery-summary-list.component';
import { TestListCellEditComponent } from './_components/test/test-list-cell-edit/test-list-cell-edit.component';

import { OwnerStmtListComponent } from './_components/owner-stmt/owner-stmt-list/owner-stmt-list.component';
import { OwnerStmtRezListComponent } from './_components/owner-stmt-rez/owner-stmt-rez-list/owner-stmt-rez-list.component';
import { OwnerStmtRezDetailListComponent } from './_components/owner-stmt-rez-detail/owner-stmt-rez-detail-list/owner-stmt-rez-detail-list.component';
import { OwnerStmtExpListComponent } from './_components/owner-stmt-exp/owner-stmt-exp-list/owner-stmt-exp-list.component';
import { OwnerStmtExpDetailListComponent } from './_components/owner-stmt-exp-detail/owner-stmt-exp-detail-list/owner-stmt-exp-detail-list.component';
import { ServiceProductListComponent } from './_components/service-product/service-product-list/service-product-list.component';
import { StatementsComponent } from './_components/owner-stmt-view/statements/statements.component';

import { ChartAccountListComponent } from './_components/chart-account/chart-account-list/chart-account-list.component';
import { ProformaListComponent } from './_components/proforma/proforma-list/proforma-list.component';
import { NoteListComponent } from './_components/task/note/note-list/note-list.component';
import { PropertyLeadProfileListComponent } from './_components/property-lead-profile/property-lead-profile-list/property-lead-profile-list.component';
import { RealtorProfileListComponent } from './_components/realtor-profile/realtor-profile-list/realtor-profile-list.component';
import { OwnerLeadProfileListComponent } from './_components/owner-lead-profile/owner-lead-profile-list/owner-lead-profile-list.component';
//import { RentalIncomeViewComponent } from './_components/rental-income-view/rental-income-view.component';
import { PropertyConditionListComponent } from './_components/property-condition/property-condition-list/property-condition-list.component';
import { RUPropertiesStatusListComponent } from './_components/ru-properties-status/ru-properties-status-list/ru-properties-status-list.component';
import { ArticleListComponent } from './_components/article/article-list/article-list.component';
import { ContentListComponent } from './_components/content/content-list/content-list.component';
import { ContentOpsComponent } from './_components/content-ops/content-ops.component';
import { ProformaViewComponent } from './_components/proforma-view/proforma-view.component';
import { ProformaTemplateListComponent } from './_components/proforma-template/proforma-template-list/proforma-template-list.component';
import { ResSalesDashboardComponent } from './_components/report/components/res-sales-dashboard/res-sales-dashboard.component';
import { ResSalesDetailsByYearDashboardComponent } from './_components/report/components/res-sales-details-by-year-dashboard/res-sales-details-by-year-dashboard.component';
import { BizDevDashboardComponent } from './_components/report/components/biz-dev-dashboard/biz-dev-dashboard.component';
import { AdminDashboardComponent } from './_components/admin-dashboard/admin-dashboard.component';
import { OccupancyDashboardComponent } from './_components/report/components/occupancy-dashboard/occupancy-dashboard.component';
import { FutureOccupancyDashboardComponent } from './_components/report/components/future-occupancy-dashboard/future-occupancy-dashboard.component';
import { OperationsDashboardComponent } from './_components/report/components/operations-dashboard/operations-dashboard.component';
import { OperationsDashboardShellComponent } from './_components/report/components/operations-dashboard-shell/operations-dashboard-shell.component';
import { OperationsDrilldownPageComponent } from './_components/report/components/operations-drilldown-page/operations-drilldown-page.component';
import { ReservationsDashboardShellComponent } from './_components/reservations-dashboard-shell/reservations-dashboard-shell.component';
import { OwnerMgmtCmsListComponent } from './_components/owner-management/owner-management-list/owner-management-list.component';
import { MaintenanceEventListComponent } from './_components/maintenance-event/maintenance-event-list/maintenance-event-list.component';
import { EmployeeAcqPaymentListComponent } from './_components/employee-acq-payment/employee-acq-payment-list/employee-acq-payment-list.component';
import { EmployeeProfileListComponent } from './_components/employee-profile/employee-profile-list/employee-profile-list.component';
import { QuartzJobListComponent } from './_components/quartz-job/quartz-job-list/quartz-job-list.component';
import { GuestArrivalListComponent } from './_components/guest-arrival/components/guest-arrival-list/guest-arrival-list.component';
import { ArrivalsBoardComponent } from './_components/arrivals-board/arrivals-board.component';
import { ArrivalsAgentBoardComponent } from './_components/arrivals-agent/arrivals-agent-board.component';
import { MsgTemplateListComponent } from './_components/msg-template/msg-template-list/msg-template-list.component';
import { OwnerReviewListComponent } from './_components/owner-review/components/owner-review-list/owner-review-list.component';
import { EmployeePtoListComponent } from './_components/employee-pto/employee-pto-list/employee-pto-list.component';
import { FeaturePivotSummaryComponent } from './_components/feature/feature-pivot-summary/feature-pivot-summary.component';
import { BizdevDashboardComponent } from './_components/bizdev-dashboard/bizdev-dashboard.component';
import { BizdevHomeComponent } from './_components/bizdev-home/bizdev-home.component';
import { BizdevLookupAdminComponent } from './_components/bizdev-lookup-admin/bizdev-lookup-admin.component';
import { BizdevPipelineComponent } from './_components/bizdev-pipeline/bizdev-pipeline.component';
import { VehicleBookingListComponent } from './_components/vehicle-booking/vehicle-booking-list/vehicle-booking-list.component';
import {ImapConfigurationListComponent} from '@app/_components/imap-configuration/imap-configuration-list/imap-configuration-list.component';
import {RealEstateListComponent} from "@app/_components/real-estate/real-estate-list/real-estate-list.component";
import {ContactListComponent} from '@app/_components/contact/contact-list/contact-list.component';
import { FaqCategoryComponent } from './_components/faq-category/faq-category/faq-category.component';
import { FaqCategoryListComponent } from './_components/faq-category/faq-category-list/faq-category-list.component';
import { FaqSectionListComponent } from './_components/faq-section/faq-section-list/faq-section-list.component';
import { FaqListComponent } from './_components/faq/faq-list/faq-list.component';
import { InboxListComponent } from './_components/inbox/inbox-list/inbox-list.component';
import { MktgLetterListComponent } from './_components/mktg-letter/mktg-letter-list/mktg-letter-list.component';
import { BlogListComponent } from './_components/blog/blog-list/blog-list.component';
import { YieldMaxComponent } from './_components/yield-max/yield-max.component';
import { ArrivalDepartureReportComponent } from './_components/report/reports/arrival-departure-report/arrival-departure-report.component';
import { OrderTaxListComponent } from './_components/order-tax/order-tax-list/order-tax-list.component';
import { OrderProductShortTermRentalJoinListComponent } from './_components/order-products-short-term-rental-join/order-products-short-term-rental-join-list/order-products-short-term-rental-join-list.component';
import { OrderProductTaxJoinListComponent } from './_components/order-product-tax-join/order-product-tax-join-list/order-product-tax-join-list.component';
import { GuestExitSurveyListComponent } from './_components/guest-exit-survey/guest-exit-survey-list/guest-exit-survey-list.component';
import { GuestRequestListComponent } from './_components/guest-request-list/guest-request-list.component';
import { OrderTaxShortTermRentalJoinListComponent } from './_components/order-tax-short-term-rental-join/order-tax-short-term-rental-join-list/order-tax-short-term-rental-join-list.component';
import { PropertyConfigComponent } from './_components/yield-max/property-config/property-config.component';
import {TeamListComponent} from '@app/_components/team/team-list/team-list.component';
import { RUReservationsListComponent } from './_components/ru-reservations/ru-reservations-list/ru-reservations-list.component';
import { PropertyListDetailsComponent } from './_components/property/property-list-details/property-list-details.component';
import {PublicTaskListComponent} from '@app/_components/task/public-task-list/public-task-list.component';
import {TagListComponent} from '@app/_components/tag/tag-list/tag-list.component';
import {TrackedLinkListComponent} from '@app/_components/tracked-link/tracked-link-list/tracked-link-list.component';
import { TemplateAnalyticsComponent } from '@app/_components/tracked-link/template-analytics/template-analytics.component';
import { CampaignAnalyticsComponent } from '@app/_components/tracked-link/campaign-analytics/campaign-analytics.component';
import { AppEventListComponent } from '@app/_components/app-event/app-event-list.component';
import {OwnerLeadProfileComponent} from '@app/_components/owner-lead-profile/owner-lead-profile/owner-lead-profile.component';
import { MsgUnsubscribeListComponent } from './_components/msg-unsubscribe/msg-unsubscribe-list/msg-unsubscribe-list.component';
import {InboxListVerticalComponent} from '@app/_components/inbox/inbox-list-vertical/inbox-list-vertical.component';
import { TapeChartWikiListComponent } from './_components/tape-chart-wiki/tape-chart-wiki-list/tape-chart-wiki-list.component';
import { BestFitListComponent } from './_components/best-fit/best-fit-list/best-fit-list.component';
import { OrderListComponent } from './_components/order/order-list/order-list.component';
import { OrderComponent } from './_components/order/order/order.component';
import { OpsDashboardComponent } from './_components/yield-max/ops-dashboard/ops-dashboard/ops-dashboard.component';
import {HelpListComponent} from '@app/_components/help/help-list/help-list.component';
import { LogmanYieldMaxListComponent } from './_components/yield-max/logman-yieldmax/components/logman-yieldmax-list/logman-yieldmax-list.component';
import { LogmanYieldMaxComponent } from './_components/yield-max/logman-yieldmax/components/logman-yieldmax/logman-yieldmax.component';
import { CompareWikiReservationListComponent } from './_components/compare-wiki-reservation/compare-wiki-reservation-list/compare-wiki-reservation-list.component';
import { RateListComponent } from './_components/yield-max/rate-yieldmax/rate-yieldmax-list/rate-yieldmax-list.component';
import { RatesLosListComponent } from './_components/yield-max/ratelos-yieldmax/ratelos-yieldmax-list/ratelos-yieldmax-list.component';
import { PropertiesListComponent } from './_components/yield-max/property/property-list/property-list.component';
import { ReservationsListComponent } from './_components/yield-max/reservation/reservation-list/reservation-list.component';
import { CompendiumListComponent } from './_components/compendium/compendium-list/compendium-list.component';
import {CheckDoubleBookingListComponent} from "./_components/check-double-booking/check-double-booking-list/check-double-booking-list.component";
import { GuestMasterProfileComponent } from './_components/guest-master-profile/guest-master-profile/guest-master-profile.component';
import { GuestMasterProfileListComponent } from './_components/guest-master-profile/guest-master-profile-list/guest-master-profile-list.component';
import { ReservationLedgerListSummaryComponent } from './_components/reservation/components/reservation-ledger-list-summary/reservation-ledger-list-summary.component';
import {
	CompareReservationLedgerListComponent
} from "@app/_components/compare-reservation-ledger/compare-reservation-ledger-list/compare-reservation-ledger-list.component";
import {
	RuAvailabilityValidateListComponent
} from "@app/_components/ru-availability-validate/ru-availability-validate-list/ru-availability-validate-list.component";
import { RateReportComponent } from './_components/yield-max/ops-dashboard/rates-report/rates-report.component';
import { QuoteListComponent } from './_components/quote/quote-list/quote-list.component';
import { QuoteComponent } from './_components/quote/quote/quote.component';
import { ReservationLedgerSummaryComponent } from './_components/reservation/components/reservation-ledger-summary/reservation-ledger-summary.component';
import {OwnerStatementsComponent} from "@app/_components/owner-statements/owner-statements.component";
import {StatementProductionGuideComponent} from "@app/_components/owner-statements/statement-production-guide/statement-production-guide.component";
import {StatementComponent} from "@app/_components/owner-statements/statement/statement.component";
import {ReservationBalanceDueComponent} from "@app/_components/reservation/components/reservation-balance-due/reservation-balance-due.component";
import {ReservationInOutListComponent} from "@app/_components/reservation/components/reservation-in-out-list/reservation-in-out-list.component";
import {ExpenseListComponent} from '@app/_components/expense/expense-list/expense-list.component';

import { PropertyProfileOnboardingListComponent } from './_components/property-profile-onboarding-list/property-profile-onboarding-list.component';
import { PropertyProfileOffboardingListComponent } from './_components/property-profile-offboarding-list/property-profile-offboarding-list.component';
import { MaintenanceEvent } from './_components/maintenance-event/maintenance-event';
import { MaintenanceEventComponent } from './_components/maintenance-event/maintenance-event/maintenance-event.component';
import { ResADRReportComponent } from './_components/report/reports/res-adr-report/res-adr-report.component';
import { TagRevenueReportComponent } from './_components/report/reports/tag-revenue-report/tag-revenue-report.component';
import { CompositeListingListComponent } from './_components/composite-listing/composite-listing-list/composite-listing-list.component';
import { ReservationReportComponent } from './_components/yield-max/ops-dashboard/reservation-report/reservation-report/reservation-report.component';
import {HousekeepingReportListComponent} from '@app/_components/housekeeping-report/housekeeping-report-list/housekeeping-report-list.component';
import { TravelAgentProfileListComponent } from './_components/travel-agent-profile/travel-agent-profile-list/travel-agent-profile-list.component';
import { OccMapListComponent } from './_components/yield-max/occ-map/occ-map-list/occ-map-list.component';
import { OccProfileListComponent } from './_components/yield-max/occ-profile/occ-profile-list/occ-profile-list.component';
import { OccMatrixListComponent } from './_components/yield-max/occ_matrix/occ_matrix-list/occ_matrix-list.component';
import { OccDeviationListComponent } from './_components/yield-max/occ-deviation/occ-deviation-list/occ-deviation-list.component';
import { OccDaysToArrivalListComponent } from './_components/yield-max/occ_days_to_arrival/occ_days_to_arrival-list/occ_days_to_arrival-list.component';
import { OccDaysMatrixComponent } from './_components/yield-max/occ_matrix_ui/occ_matrix_ui/occ-days-matrix.component';
import { PropertyProfileComponent } from './_components/property-profile/property-profile/property-profile.component';
import { PropertyLeadProfileComponent } from './_components/property-lead-profile/property-lead-profile/property-lead-profile.component';
import { ResMasterComponent } from './_components/report/reports/res-master/res-master.component';
import { DataReportComponent } from './_components/data-report/data-report/data-report.component';
import { ResMasterEscrowComponent } from './_components/report/reports/res-master-escrow/res-master-escrow.component';
import { TravelInsuranceReportComponent } from './_components/report/reports/travel-insurance-report/travel-insurance-report.component';
import { PaymentConfirmListComponent } from './_components/payment-confirm/payment-confirm-list/payment-confirm-list.component';
import { AiAgentListComponent } from './_components/ai-agent/ai-agent-list/ai-agent-list.component';
import { LandingPageCMSListComponent } from './_components/landing-page-cms/landing-page-cms-list/landing-page-cms-list.component';
import { AccessCodeListComponent } from './_components/access-code/access-code-list/access-code-list.component';
import { OwnerStatementsReconsiliationComponent } from './_components/owner-statements/owner-statements-reconsiliation/owner-statements-reconsiliation.component';
import { MonthlyStmtExpensesComponent } from './_components/owner-statements/monthly-stmt-expenses/monthly-stmt-expenses.component';
import { ExpenseComponent } from './_components/expense/expense/expense.component';
import { StyleguideComponent } from './_components/styleguide/styleguide.component';
import { AdminStyleguideComponent } from './_components/admin-styleguide/admin-styleguide.component';
import { QualityTestDefinitionsListComponent } from './_components/quality-test-definitions/quality-test-definitions-list/quality-test-definitions-list.component';
import { QualityTestFieldRegistryListComponent } from './_components/quality-test-definitions/quality-test-field-registry-list/quality-test-field-registry-list.component';
import { QualityTestDashboardComponent } from './_components/quality-test-definitions/quality-test-dashboard/quality-test-dashboard.component';
import { UnifiedInboxComponent } from './unified-inbox/unified-inbox.component';
import { DripCampaignTemplateListComponent } from './_components/drip/drip-campaign-template-list/drip-campaign-template-list.component';
import { DripCampaignTemplateEditComponent } from './_components/drip/drip-campaign-template-edit/drip-campaign-template-edit.component';
import { DripCampaignInstanceListComponent } from './_components/drip/drip-campaign-instance-list/drip-campaign-instance-list.component';
// import { RatesLosListComponent } from './_components/yield-max/ratelos-yieldmax/ratelos-yieldmax-list/ratelos-yieldmax-list.component';
import { QbSyncListComponent } from './_components/qb-sync/qb-sync-list.component';

// Phase 0 — Field Ops Platform
import { VendorListComponent } from './_components/vendor/vendor-list/vendor-list.component';
import { VendorEditComponent } from './_components/vendor/vendor-edit/vendor-edit.component';
import { TaskTemplateListComponent } from './_components/task-template/template-list/template-list.component';
import { TaskTemplateEditComponent } from './_components/task-template/template-edit/template-edit.component';
import { ServiceDetailRollupComponent } from './_components/task-service-detail/service-detail-rollup/service-detail-rollup.component';
import { MarketingDashboardComponent } from './_components/marketing-dashboard/marketing-dashboard.component';

const appRoutes: Routes = [
	{ path: '', component: HomeComponent, canActivate: [AuthGuard] },
	{ path: 'login', component: LoginComponent },
	{ path: 'register', component: RegisterComponent },
	{ path: 'article-list', component: ArticleListComponent, canActivate: [AuthGuard] },
	{ path: 'content-list/:id', component: ContentListComponent, canActivate: [AuthGuard] },
	{ path: 'content-list', component: ContentListComponent, canActivate: [AuthGuard] },
	{ path: 'content-ops', component: ContentOpsComponent, canActivate: [AuthGuard] },
	{ path: 'real-estate-list', component: RealEstateListComponent, canActivate: [AuthGuard] },

	// test
	{ path: 'tests', component: TestListComponent, canActivate: [AuthGuard] },
	{ path: 'teams', component: TeamListComponent, canActivate: [AuthGuard] },

	// test
	{ path: 'test-edit', component: TestListCellEditComponent, canActivate: [AuthGuard] },

	// channel
	{ path: 'channels', component: ChannelListComponent, canActivate: [AuthGuard] },

	// guest refund
	{ path: 'guest-refund-reasons', component: GuestRefundReasonListComponent, canActivate: [AuthGuard] },

	// guest refund
	{ path: 'guest-refunds', component: GuestRefundListComponent, canActivate: [AuthGuard] },

	// cancellation policy viewer
	{ path: 'cancellation-policy-view', component: CancellationPolicyViewComponent, canActivate: [AuthGuard] },

	// file-upload
	{ path: 'file-uploads', component: FileUploadListComponent, canActivate: [AuthGuard] },

	// order-product
	{ path: 'order-products', component: OrderProductListComponent, canActivate: [AuthGuard] },

	// feature
	{ path: 'features', component: FeaturesListComponent, canActivate: [AuthGuard] },

	// feature
	{ path: 'guest-moves', component: GuestMoveListComponent, canActivate: [AuthGuard] },

	// activity wish lists
	{ path: 'activity-wishlists', component: ActivityWishlistListComponent, canActivate: [AuthGuard] },
	{ path: 'activity-wishlists/:wishlistId', component: ActivityWishlistComponent, canActivate: [AuthGuard] },

	// activity
	{ path: 'activities', component: ActivityListComponent, canActivate: [AuthGuard] },

	// activity-add
	{ path: 'activity-add', component: ActivityComponent, canActivate: [AuthGuard] },

	// activity-edit
	{ path: 'activity-edit/:activityId', component: ActivityComponent, canActivate: [AuthGuard] },

	// activity-fee
	{ path: 'activity-fees', component: ActivityFeeListComponent, canActivate: [AuthGuard] },

	// activity-scheduler
	{ path: 'activity-schedulers', component: ActivityScheduleListComponent, canActivate: [AuthGuard] },

	// activity-provider
	{ path: 'activity-providers', component: ActivityProviderListComponent, canActivate: [AuthGuard] },

	// activities manager (new unified page)
	{ path: 'activities-manager', component: ActivitiesManagerComponent, canActivate: [AuthGuard] },

	// person
	{ path: 'persons', component: PersonListComponent, canActivate: [AuthGuard] },

	// person-address
	{ path: 'person-address', component: PersonAddressListComponent, canActivate: [AuthGuard] },

	// person-email
	{ path: 'person-emails', component: PersonEmailListComponent, canActivate: [AuthGuard] },

	// person-phone
	{ path: 'person-phones', component: PersonPhoneListComponent, canActivate: [AuthGuard] },

	// person-social
	{ path: 'person-socials', component: PersonSocialListComponent, canActivate: [AuthGuard] },

	// pictures
	{ path: 'pictures', component: PictureListComponent, canActivate: [AuthGuard] },

	// compendiums
	{ path: 'compendiums', component: CompendiumListComponent, canActivate: [AuthGuard] },

	// loss-found
	{ path: 'lost-and-found', component: LostFoundListComponent, canActivate: [AuthGuard] },

	// loss-found
	{ path: 'ru-detailed-location', component: RUDetailedLocationListComponent, canActivate: [AuthGuard] },

	// cost-profile
	{ path: 'cost-profile', component: CostProfileListComponent, canActivate: [AuthGuard] },

	// cost-profile
	{ path: 'guest-campaign', component: GuestCampaignComponent, canActivate: [AuthGuard] },

	// cost-profile
	{ path: 'property-features', component: PropertyFeatureListComponent, canActivate: [AuthGuard] },

	// code-projects
	{ path: 'code-projects', component: CodeProjectListComponent, canActivate: [AuthGuard] },

	// code-projects
	{ path: 'code-tasks', component: CodeTaskListComponent, canActivate: [AuthGuard] },

	// code-projects
	{ path: 'composite-listings', component: CompositeListingListComponent, canActivate: [AuthGuard] },

	// property-feature-templates
	{ path: 'property-feature-templates', component: PropertyFeatureTemplateListComponent, canActivate: [AuthGuard] },

	// property-summary-list
	{ path: 'property-summary-list', component: PropertySummaryListComponent, canActivate: [AuthGuard] },

	// blog-list
	{ path: 'blog-list', component: BlogListComponent, canActivate: [AuthGuard] },

	// proforma-view
	{ path: 'proforma-view', component: ProformaViewComponent, canActivate: [AuthGuard] },

	// property-condition
	{ path: 'property-condition-list', component: PropertyConditionListComponent, canActivate: [AuthGuard] },

	// property-condition
	{ path: 'ru-properties-status-list', component: RUPropertiesStatusListComponent, canActivate: [AuthGuard] },

	// res-sales-dashboard
	{ path: 'res-sales-dashboard', component: ResSalesDashboardComponent, canActivate: [AuthGuard] },

	// res-master
	{ path: 'res-master', component: ResMasterComponent, canActivate: [AuthGuard] },
	{ path: 'res-master-escrow', component: ResMasterEscrowComponent, canActivate: [AuthGuard] },

  // Travel insurance report
  { path: 'travel-insurance-report', component: TravelInsuranceReportComponent, canActivate: [AuthGuard] },

	// res-sales-dashboard-by-year
	{ path: 'res-sales-dashboard-by-year', component: ResSalesDetailsByYearDashboardComponent, canActivate: [AuthGuard] },

	// biz-dev-dashboard
	{ path: 'biz-dev-dashboard', component: BizDevDashboardComponent, canActivate: [AuthGuard] },

	// admin-dashboard
	{ path: 'admin-dashboard', component: AdminDashboardComponent, canActivate: [AuthGuard] },

	// occupancy-dashboard
	{ path: 'occupancy-dashboard', component: OccupancyDashboardComponent, canActivate: [AuthGuard] },

	// future-occupancy-dashboard
	{ path: 'future-occupancy-dashboard', component: FutureOccupancyDashboardComponent, canActivate: [AuthGuard] },

	// operations-dashboard — v2 shell wraps Dhruvit's component with Option C chrome
	{ path: 'operations-dashboard', component: OperationsDashboardShellComponent, canActivate: [AuthGuard] },

	// reservations-home — v2 team-landing for Reservations / Guest Services (Phase 2)
	// Same wrapper pattern as the Ops shell. Comms-hub landing for front-line agents
	// who handle reservations, quotes, refunds, and multi-context messaging.
	{ path: 'reservations-home', component: ReservationsDashboardShellComponent, canActivate: [AuthGuard] },
	// operations-dashboard/drilldown — full-page drill-down. Receives data via
	// router.navigate(..., { state: { metric, rows, title, ... } }) so it never
	// has to fetch (and never has to do a post-mount state transition, which
	// fails in this codebase's CD pipeline).
	{ path: 'operations-dashboard/drilldown', component: OperationsDrilldownPageComponent, canActivate: [AuthGuard] },

	// owner-management-cms
	{ path: 'owner-management-cms', component: OwnerMgmtCmsListComponent, canActivate: [AuthGuard] },

	// guest-arrival-list
	{ path: 'payment-confirm-list', component: PaymentConfirmListComponent, canActivate: [AuthGuard] },

	// guest-arrival-list
	{ path: 'guest-arrival-list', component: GuestArrivalListComponent, canActivate: [AuthGuard] },

	// arrivals-board — live changeover agent board
	{ path: 'arrivals-board', component: ArrivalsBoardComponent, canActivate: [AuthGuard] },

	// arrivals-agent — multi-stage arrival text engine board (Room Status driven)
	{ path: 'arrivals-agent', component: ArrivalsAgentBoardComponent, canActivate: [AuthGuard] },

	// guest-arrival-list
	{ path: 'travel-agent-profile-list', component: TravelAgentProfileListComponent, canActivate: [AuthGuard] },

	// arrival-departure-report
	{ path: 'arrival-departure-report', component: ArrivalDepartureReportComponent, canActivate: [AuthGuard] },

	// order-tax
	{ path: 'order-taxes', component: OrderTaxListComponent, canActivate: [AuthGuard] },

	// order-tax-short-term-rental-joins
	{ path: 'order-tax-short-term-rental-join', component: OrderTaxShortTermRentalJoinListComponent, canActivate: [AuthGuard] },

	// guest-exit-survey

	{ path: 'guest-exit-survey', component: GuestExitSurveyListComponent, canActivate: [AuthGuard] },

	// guest-request-list (dedicated guest portal requests page)
	{ path: 'guest-requests', component: GuestRequestListComponent, canActivate: [AuthGuard] },

	// order-tax
	{ path: 'order-product-tax-join', component: OrderProductTaxJoinListComponent, canActivate: [AuthGuard] },

	// ru-reservations
	{ path: 'ru-reservations', component: RUReservationsListComponent, canActivate: [AuthGuard] },

	{ path: 'onboardings', component: PropertyProfileOnboardingListComponent, canActivate: [AuthGuard] },

	{ path: 'offboardings', component: PropertyProfileOffboardingListComponent, canActivate: [AuthGuard] },

	// order-product-short-term-rental-join
	{ path: 'order-product-short-term-rental-join', component: OrderProductShortTermRentalJoinListComponent, canActivate: [AuthGuard] },

	// user
	{
		path: 'users', component: UserComponent, canActivate: [AuthGuard], resolve: {
			// userRoleListResApi is the list of roles from the db
			userRoleListResApi: UserRoleListResolver
		}
	},
	{
		path: 'user-add', component: UserComponent, canActivate: [AuthGuard], resolve: {
			userRoleListResApi: UserRoleListResolver
		}
	},
	{
		path: 'user-edit/:userId', component: UserComponent, canActivate: [AuthGuard], resolve: {
			userRoleListResApi: UserRoleListResolver,
			userResApi: UserResolver
		}
	},
	{
		path: 'user-view/:userId', component: UserComponent, canActivate: [AuthGuard], resolve: {

			// list of all possible user roles
			userRoleListResApi: UserRoleListResolver,

			// userApi
			userResApi: UserResolver
		}
	},
	{ path: 'user-list', component: UserComponent, canActivate: [AuthGuard] },

	// userRole
	{
		path: 'user-role-add',
		component: UserRoleComponent, canActivate: [AuthGuard]
	},
	{
		path: 'user-role-edit/:userRoleId',
		component: UserRoleComponent, canActivate: [AuthGuard]
	},
	{
		path: 'user-role-view/:userRoleId',
		component: UserRoleComponent, canActivate: [AuthGuard]
	},
	{
		path: 'user-role-list',
		component: UserRoleListComponent, canActivate: [AuthGuard]
	},

	// passwords
	{
		path: 'password-reset',
		component: PasswordResetComponent
	},
	{
		path: 'password-reset-request',
		component: PasswordResetRequestComponent
	},

	// owner profile
	{
		path: 'owner-profile', component: OwnerProfileComponent, canActivate: [AuthGuard]
	},
	{
		path: 'owner-profile/:ownerProfileId', component: OwnerProfileComponent, canActivate: [AuthGuard], resolve: {
			shortTermRentalsList: PropertyListResolver
		}
	},
	{
		path: 'owner-profile-list', component: OwnerProfileListComponent, canActivate: [AuthGuard]
	},

	// guest profile
	{
		path: 'guest-profile', component: GuestProfileComponent, canActivate: [AuthGuard]
	},
	{
		path: 'guest-profile/:guestProfileId', component: GuestProfileComponent, canActivate: [AuthGuard], resolve: {
			shortTermRentalsList: PropertyListResolver
		}
	},
	{
		path: 'guest-profile-list', component: GuestProfileListComponent, canActivate: [AuthGuard]
	},

	// guest master profile
	{
		path: 'guest-master-profile', component: GuestMasterProfileComponent, canActivate: [AuthGuard]
	},
	{
		path: 'guest-master-profile/:guestMasterProfileId', component: GuestMasterProfileComponent, canActivate: [AuthGuard], resolve: {
			shortTermRentalsList: PropertyListResolver
		}
	},
	{
		path: 'guest-master-profile-list', component: GuestMasterProfileListComponent, canActivate: [AuthGuard]
	},

	// owner stmt
	{ path: 'owner-stmt-list', component: OwnerStmtListComponent, canActivate: [AuthGuard] },

  { path: 'expense-list', component: ExpenseListComponent, canActivate: [AuthGuard] },

  { path: 'expense/:expenseId', component: ExpenseComponent, canActivate: [AuthGuard] },


	// owner stmt rez
	{ path: 'owner-stmt-rez-list', component: OwnerStmtRezListComponent, canActivate: [AuthGuard] },

	// owner stmt rez detail
	{ path: 'owner-stmt-rez-detail-list', component: OwnerStmtRezDetailListComponent, canActivate: [AuthGuard] },

	// owner stmt exp
	{ path: 'owner-stmt-exp-list', component: OwnerStmtExpListComponent, canActivate: [AuthGuard] },

	// owner stmt exp detail list
	{ path: 'owner-stmt-exp-detail-list', component: OwnerStmtExpDetailListComponent, canActivate: [AuthGuard] },

	// Service Product list
	{ path: 'service-product-list', component: ServiceProductListComponent, canActivate: [AuthGuard] },

	// Owner Statement View
	{ path: 'statements', component: StatementsComponent, canActivate: [AuthGuard] },
	{ path: 'owner-stmt-preview/:ownerStmtId', component: StatementsComponent, canActivate: [AuthGuard] },

	// Chart Account View
	{ path: 'chart-account-list', component: ChartAccountListComponent, canActivate: [AuthGuard] },

	//proforma
	{ path: 'proforma-list', component: ProformaListComponent , canActivate: [AuthGuard] },

	//proforma by id
	{ path: 'proforma-list/:proformaId', component: ProformaListComponent, canActivate: [AuthGuard] },

	//proforma templates
	{ path: 'proforma-template-list', component: ProformaTemplateListComponent, canActivate: [AuthGuard] },

	//vehicle booking
	{ path: 'vehicle-booking', component: VehicleBookingListComponent , canActivate: [AuthGuard] },
	{ path: 'vehicle-booking/:vehicleBookingId', component: VehicleBookingListComponent , canActivate: [AuthGuard] },

	// Note
	{ path: 'note-list', component: NoteListComponent , canActivate: [AuthGuard] },

	//proforma - PropertyLeadProfileListComponent

	{ path: 'property-lead-profile-list', component: PropertyLeadProfileListComponent , canActivate: [AuthGuard] },

	{ path: 'property-lead-profile/:propertyLeadProfileId', component: PropertyLeadProfileComponent , canActivate: [AuthGuard] },

	//proforma - RealtorProfileListComponent

	{ path: 'realtor-profile-list', component: RealtorProfileListComponent , canActivate: [AuthGuard] },

	//proforma - OwnerLeadProfileListComponent

	{ path: 'owner-lead-profile-list', component: OwnerLeadProfileListComponent , canActivate: [AuthGuard] },
	{ path: 'owner-lead-profile-view/:ownerLeadProfileId', component: OwnerLeadProfileComponent , canActivate: [AuthGuard] },
	// guest refund
	{ path: 'owner-profile-guest-list', component: OwnerProfileGuestListComponent, canActivate: [AuthGuard] },

	{ path: 'msg-unsubscribe-list', component: MsgUnsubscribeListComponent, canActivate: [AuthGuard] },

	// quality-test
	{ path: 'quality-test', component: QualityTestDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'quality-test-raw', component: ListingQualityStatusListComponent, canActivate: [AuthGuard] },
	{ path: 'quality-test-definitions', component: QualityTestDefinitionsListComponent, canActivate: [AuthGuard] },
	{ path: 'quality-test-field-registry', component: QualityTestFieldRegistryListComponent, canActivate: [AuthGuard] },
	{ path: 'quality-test-dashboard', component: QualityTestDashboardComponent, canActivate: [AuthGuard] },

	// data-report
	{ path: 'data-report', component: DataReportComponent, canActivate: [AuthGuard] },

	// msg
	{ path: 'msg-list', component: MsgListComponent, canActivate: [AuthGuard] },

	// msg-recipient
	{ path: 'msg-recipient-list', component: MsgRecipientListComponent, canActivate: [AuthGuard] },

	// faq-category
	{ path: 'faq-category-list', component: FaqCategoryListComponent, canActivate: [AuthGuard] },

	// faq-category
	{ path: 'faq-section-list', component: FaqSectionListComponent, canActivate: [AuthGuard] },

	// faq-category
	{ path: 'faq-list', component: FaqListComponent, canActivate: [AuthGuard] },

	// msg-campaign
	{ path: 'msg-campaign-list', component: MsgCampaignListComponent, canActivate: [AuthGuard] },
	{ path: 'imap-configuration-list', component: ImapConfigurationListComponent, canActivate: [AuthGuard] },
	{ path: 'inbox-list', component: InboxListComponent, canActivate: [AuthGuard] },
	{ path: 'inbox-list-vertical', component: InboxListVerticalComponent, canActivate: [AuthGuard] },
	{ path: 'contact-list', component: ContactListComponent, canActivate: [AuthGuard] },
	{ path: 'reservation-ledger-summary', component: ReservationLedgerSummaryComponent, canActivate: [AuthGuard] },

	// msg-campaign
	{ path: 'msg-template-list', component: MsgTemplateListComponent, canActivate: [AuthGuard] },

	//
	{ path: 'mktg-letter-list', component: MktgLetterListComponent, canActivate: [AuthGuard] },

	// msgs
	{ path: 'msg-history', component: MsgListComponent, canActivate: [AuthGuard] },

	// question-answer
	{ path: 'question-answers', component: QuestionAnswerListComponent, canActivate: [AuthGuard] },

	// property-config
	{ path: 'property-config/:propertyId', component: PropertyConfigComponent, canActivate: [AuthGuard] },
	{ path: 'property-config/:propertyId/:defaultTabIndx', component: PropertyConfigComponent, canActivate: [AuthGuard] },
	{ path: 'property-config/:propertyId/:rateBucketId', component: PropertyConfigComponent, canActivate: [AuthGuard] },
	{ path: 'property-config/:propertyId/:rateBucketId/:defaultTabIndx', component: PropertyConfigComponent, canActivate: [AuthGuard] },
	{ path: 'property-config/:propertyId/:rateBucketId/:defaultTabIndx/:checkInDate/:checkOutDate', component: PropertyConfigComponent, canActivate: [AuthGuard] },

	// property
	{
		path: 'property-add', component: PropertyComponent, canActivate: [AuthGuard], resolve:
		{
			availablePropertyFeaturesResApi: AvailablePropertyFeaturesResolver,
		}
	},
	{
		path: 'property-edit/:shortTermRentalId', component: PropertyComponent, canActivate: [AuthGuard], resolve: {
			availablePropertyFeaturesResApi: AvailablePropertyFeaturesResolver,
			propertyResApi: PropertyResolver
		}
	},
	{
		path: 'property-view/:shortTermRentalId', component: PropertyComponent, canActivate: [AuthGuard], resolve: {
			availablePropertyFeaturesResApi: AvailablePropertyFeaturesResolver,
			propertyResApi: PropertyResolver
		}
	},
	{ path: 'property-list', component: PropertyListComponent, canActivate: [AuthGuard] },
	{ path: 'property-delete/:shortTermRentalId', component: PropertyDeleteComponent, canActivate: [AuthGuard] },

	{ path: 'property-list-details', component: PropertyListDetailsComponent, canActivate: [AuthGuard] },
	// development
	{
		path: 'development-add', component: DevelopmentComponent, canActivate: [AuthGuard], resolve: {
			availableDevelopmentFeaturesResApi: AvailableDevelopmentFeaturesResolver
		}
	},
	{
		path: 'development-edit/:developmentId', component: DevelopmentComponent, canActivate: [AuthGuard], resolve: {
			availableDevelopmentFeaturesResApi: AvailableDevelopmentFeaturesResolver
		}
	},
	{
		path: 'development-view/:developmentId', component: DevelopmentComponent, canActivate: [AuthGuard], resolve: {
			availableDevelopmentFeaturesResApi: AvailableDevelopmentFeaturesResolver
		}
	},
	{ path: 'development-list', component: DevelopmentListComponent, canActivate: [AuthGuard] },


	// orders
	{ path: 'review-list', component: ReviewListComponent, canActivate: [AuthGuard] },

	// reviews
	{ path: 'order/:orderId', component: OrderComponent, canActivate: [AuthGuard] },
  { path: 'reservation-ledger/:reservationId', component: ReservationLedgerListComponent, canActivate: [AuthGuard] },

	// reviews
	{ path: 'order-list', component: OrderListComponent, canActivate: [AuthGuard] },

	// owner reviews
	{ path: 'owner-review-list', component: OwnerReviewListComponent, canActivate: [AuthGuard] },

	// jobs
	{ path: 'jobs', component: JobListComponent, canActivate: [AuthGuard] },

	// reservation-ledgers
	{ path: 'reservation-ledgers', component: ReservationLedgerListComponent, canActivate: [AuthGuard] },

	// reservation-ledgers-summary
	{ path: 'reservation-ledgers-summary', component: ReservationLedgerListSummaryComponent, canActivate: [AuthGuard] },

	// property profile
	{ path: 'property-profile', component: PropertyProfileListComponent, canActivate: [AuthGuard] },

	{ path: 'property-profile/:propertyProfileId', component: PropertyProfileComponent, canActivate: [AuthGuard] },

	// bizdev home — daily starting page for sales agents
	{ path: 'bizdev-home', component: BizdevHomeComponent, canActivate: [AuthGuard] },

	// property profile
	{ path: 'bizdev-dashboard', component: BizdevDashboardComponent, canActivate: [AuthGuard] },

	// real-time sales pipeline dashboard
	{ path: 'bizdev/pipeline', component: BizdevPipelineComponent, canActivate: [AuthGuard] },

	// bizdev lookup admin (competitor / win-reason / loss-reason / etc reference data)
	{ path: 'bizdev/lookups', component: BizdevLookupAdminComponent, canActivate: [AuthGuard] },

	// quote
	{
		path: 'quote', component: QuoteComponent, canActivate: [AuthGuard]
	},
	{
		path: 'quote/:quoteId', component: QuoteComponent, canActivate: [AuthGuard], resolve: {
			shortTermRentalsList: PropertyListResolver
		}
	},
	{
		path: 'quote-list', component: QuoteListComponent, canActivate: [AuthGuard]
	},

	// rate-report
	{ path: 'rate-report', component: RateReportComponent, canActivate: [AuthGuard] },

	// feature pivote summary
	{ path: 'feature-pivot-summary', component: FeaturePivotSummaryComponent, canActivate: [AuthGuard] },

	// rateProfile
	{ path: 'rate-profile-add', component: RateProfileComponent, canActivate: [AuthGuard] },
	{ path: 'rate-profile-edit/:rateProfileId', component: RateProfileComponent, canActivate: [AuthGuard] },
	{ path: 'rate-profile-view/:rateProfileId', component: RateProfileComponent, canActivate: [AuthGuard] },
	{ path: 'rate-profile-list', component: RateProfileListComponent, canActivate: [AuthGuard] },

	// rateManager
	{ path: 'rate-manager', component: RateManagerComponent, canActivate: [AuthGuard] },
	{ path: 'rate-manager-add', component: RateManagerComponent, canActivate: [AuthGuard] },
	{ path: 'rate-manager-edit/:rateManagerId', component: RateManagerComponent, canActivate: [AuthGuard] },
	{ path: 'rate-manager-view/:rateManagerId', component: RateManagerComponent, canActivate: [AuthGuard] },
	{ path: 'rate-manager-list', component: RateManagerListComponent, canActivate: [AuthGuard] },

	// rateSummary
	{ path: 'rate-summary', component: RateSummaryComponent, canActivate: [AuthGuard] },

	// rateBucket
	{ path: 'rate-buckets', component: RateBucketComponent, canActivate: [AuthGuard] },

	// ai-agents
	{ path: 'ai-agents', component: AiAgentListComponent, canActivate: [AuthGuard] },

	// landing-page-cms
	{ path: 'landing-page-cms', component: LandingPageCMSListComponent, canActivate: [AuthGuard] },

	// ai-agents
	{ path: 'access-codes', component: AccessCodeListComponent, canActivate: [AuthGuard] },

	// rateBucket
	{ path: 'rate-bucket-details', component: RateBucketDetailComponent, canActivate: [AuthGuard] },

	// rateOverride
	{ path: 'rate-override', component: RateOverrideComponent, canActivate: [AuthGuard] },
	{ path: 'rate-override-list', component: RateOverrideComponent, canActivate: [AuthGuard] },

	// rentals-united
	{ path: 'rentals-united', component: RentalsUnitedComponent, canActivate: [AuthGuard] },

	// vrbo logman
	{ path: 'vrbo-logman', component: VRBOLogmanComponent, canActivate: [AuthGuard] },

	// vrbo
	{ path: 'vrbo', component: VRBOComponent, canActivate: [AuthGuard] },
	{ path: 'vrbo-reviews', component: VRBOReviewsComponent, canActivate: [AuthGuard] },
	{ path: 'vrbo-promotions-dashboard', component: VRBOPromotionsDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'vrbo-promotions', component: VRBOPromotionsDashboardComponent, canActivate: [AuthGuard] },

	// google
	{ path: 'google', component: GoogleComponent, canActivate: [AuthGuard] },

	// google logman
	{ path: 'google-logman', component: GoogleLogmanComponent, canActivate: [AuthGuard] },

	// reports
	{ path: 'reports-dashboard', component: ReportsDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'daily-report', component: DailySummaryReportComponent, canActivate: [AuthGuard] },
	{ path: 'res-sales-report', component: ResSalesReportComponent, canActivate: [AuthGuard] },
	{ path: 'res-channel-report', component: ReservationReportComponent, canActivate: [AuthGuard] },
	{ path: 'vacancy-report', component: VacancyReportComponent, canActivate: [AuthGuard] },
	{ path: 'res-rev-report', component: ResRevReportComponent, canActivate: [AuthGuard] },
	{ path: 'occupancy-summary-report', component: OccupancySummaryReportComponent, canActivate: [AuthGuard] },
	{ path: 'future-occupancy-report', component: FutureOccupancyReportComponent, canActivate: [AuthGuard] },
	{ path: 'analytics-dashboard', component: AnalyticsDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'quote-analytics', component: QuoteAnalyticsComponent, canActivate: [AuthGuard] },
	{ path: 'check-in-out-report', component: CheckInOutReportComponent, canActivate: [AuthGuard] },
	{ path: 'escrows-report', component: EscrowsReportComponent, canActivate: [AuthGuard] },
	{ path: 'escrow-report', component: EscrowReportComponent, canActivate: [AuthGuard] },
	{ path: 'escrow-report/audit', component: EscrowReportAuditComponent, canActivate: [AuthGuard] },
	{ path: 'escrow-report/payment-mapping', component: EscrowPaymentMappingComponent, canActivate: [AuthGuard] },
	{ path: 'res-adr-report', component: ResADRReportComponent, canActivate: [AuthGuard] },
	{ path: 'reports/tag-revenue', component: TagRevenueReportComponent, canActivate: [AuthGuard] },
	{ path: 'reservation-summary-report', component: ReservationSummaryReportComponent, canActivate: [AuthGuard] },
	{ path: 'payment-summary-report', component: PaymentSummaryReportComponent, canActivate: [AuthGuard] },

	// logman Wiki
	{ path: 'logmans', component: LogmanListComponent, canActivate: [AuthGuard] },
	{ path: 'logmans/short-term-rental/:referenceId/:shortTermRentalId', component: LogmanListComponent, canActivate: [AuthGuard] },
	{ path: 'logmans/reservation/:referenceId/:reservationId', component: LogmanListComponent, canActivate: [AuthGuard] },
	{ path: 'logmans/:referenceId', component: LogmanListComponent, canActivate: [AuthGuard] },
	{ path: 'logmans/:referenceId/:severity', component: LogmanListComponent, canActivate: [AuthGuard] },

	// logman Yieldmax
	{ path: 'logmans-yieldmax', component: LogmanYieldMaxListComponent, canActivate: [AuthGuard] },
	{ path: 'logmans-yieldmax/:referenceId', component: LogmanYieldMaxListComponent, canActivate: [AuthGuard] },
	{ path: 'logmans-yieldmax/:referenceId/:severity', component: LogmanYieldMaxListComponent, canActivate: [AuthGuard] },
	{ path: 'logmans-yieldmax/:referenceId/:severity/:day', component: LogmanYieldMaxListComponent, canActivate: [AuthGuard] },

	{ path: 'maintenance-event', component: MaintenanceEventListComponent, canActivate: [AuthGuard] },

	{ path: 'maintenance-event/:maintenanceEventId', component: MaintenanceEventComponent, canActivate: [AuthGuard] },

	{ path: 'employee-acq-payment', component: EmployeeAcqPaymentListComponent, canActivate: [AuthGuard] },
	{ path: 'employee-profile', component: EmployeeProfileListComponent, canActivate: [AuthGuard] },
	{ path: 'employee-ptos', component: EmployeePtoListComponent, canActivate: [AuthGuard] },


	//Tape Chart
	{ path: 'tapechart', component: TapeChartWikiListComponent, canActivate: [AuthGuard] },
	{ path: 'best-fit-list', component: BestFitListComponent, canActivate: [AuthGuard] },
	{ path: 'tapechart/:shortTermRentalId', component: TapeChartWikiListComponent, canActivate: [AuthGuard] },
	{ path: 'tapechart/:shortTermRentalId/:startDate', component: TapeChartWikiListComponent, canActivate: [AuthGuard] },
	{ path: 'tapechart/:shortTermRentalId/:startDate/:endDate', component: TapeChartWikiListComponent, canActivate: [AuthGuard] },
	{ path: 'tapechart/:shortTermRentalId/:startDate/:endDate/:minStayExpected', component: TapeChartWikiListComponent, canActivate: [AuthGuard] },

	//Rate
	{ path: 'rates', component: RateListComponent, canActivate: [AuthGuard] },
	{ path: 'rates/:createDate', component: RateListComponent, canActivate: [AuthGuard] },
	{ path: 'rates/:updateDate', component: RateListComponent, canActivate: [AuthGuard] },

	//RateLos
	{ path: 'ratesLos', component: RatesLosListComponent, canActivate: [AuthGuard] },
	{ path: 'ratesLos/:createDate', component: RatesLosListComponent, canActivate: [AuthGuard] },
	{ path: 'ratesLos/:updateDate', component: RatesLosListComponent, canActivate: [AuthGuard] },

	//YM Properies
	{ path: 'ym-properties', component: PropertiesListComponent, canActivate: [AuthGuard] },
	{ path: 'ym-properties/:createDate', component: PropertiesListComponent, canActivate: [AuthGuard] },
	{ path: 'ym-properties/:updateDate', component: PropertiesListComponent, canActivate: [AuthGuard] },

	//YM Reservations
	{ path: 'ym-reservations', component: ReservationsListComponent, canActivate: [AuthGuard] },
	{ path: 'ym-reservations/:createDate', component: ReservationsListComponent, canActivate: [AuthGuard] },
	{ path: 'ym-reservations/:updateDate', component: ReservationsListComponent, canActivate: [AuthGuard] },

	//Occupancy Map
	{ path: 'occ-maps', component: OccMapListComponent, canActivate: [AuthGuard] },
	{ path: 'occ-profiles', component: OccProfileListComponent, canActivate: [AuthGuard] },
	{ path: 'occ-matrix', component: OccMatrixListComponent, canActivate: [AuthGuard] },
	{ path: 'occ-deviation', component: OccDeviationListComponent, canActivate: [AuthGuard] },
	{ path: 'occ-days-to-arrival', component: OccDaysToArrivalListComponent, canActivate: [AuthGuard] },
	{ path: 'occ-days-matrix', component: OccDaysMatrixComponent, canActivate: [AuthGuard] },

	// reservations
	// rateBucket
	{ path: 'reservations', component: ReservationListComponent, canActivate: [AuthGuard] },
  { path: 'reservation-balance-due', component: ReservationBalanceDueComponent, canActivate: [AuthGuard] },
  { path: 'reservation-in-out-list', component: ReservationInOutListComponent, canActivate: [AuthGuard] },
  { path: 'owner-statements', component: OwnerStatementsComponent, canActivate: [AuthGuard] },
  { path: 'owner-statements-help', component: StatementProductionGuideComponent, canActivate: [AuthGuard] },
	{ path: 'owner-statements-reconciliation', component: OwnerStatementsReconsiliationComponent, canActivate: [AuthGuard] },
	{ path: 'owner-statement-expenses', component: MonthlyStmtExpensesComponent, canActivate: [AuthGuard] },
  { path: 'owner-statement/:orderId', component: StatementComponent, canActivate: [AuthGuard] },
	{ path: 'reservation-add', component: ReservationComponent, canActivate: [AuthGuard] },
	{ path: 'inbox-list-vertical/:contextId', component: InboxListVerticalComponent, canActivate: [AuthGuard] },
	{ path: 'inbox-list-vertical/:contextId/:subContextId/:status', component: InboxListVerticalComponent, canActivate: [AuthGuard] },
  { path: 'inbox-list-vertical/:msgTopic/:defaultImapConfId', component: InboxListVerticalComponent, canActivate: [AuthGuard] },
	{
		path: 'reservations/:reservationId', component: ReservationContainerComponent, canActivate: [AuthGuard], resolve: {
			reservationResApi: ReservationResolver
		}
	},
	{ path: 'reservations-edit/:reservationId', component: ReservationComponent, canActivate: [AuthGuard] },
	{ path: 'reservations/property/:propertyCode', component: ReservationListComponent, canActivate: [AuthGuard]},

	// task
	{ path: 'task-add', component: TaskComponent, canActivate: [AuthGuard] },
	{
		path: 'task-edit/:taskId', component: TaskComponent, canActivate: [AuthGuard], resolve: {
			taskApiResponse: TaskResolver
		}
	},
	{
		path: 'task-view/:taskId', component: TaskComponent, canActivate: [AuthGuard], resolve: {
			taskApiResponse: TaskResolver
		}
	},
	{ path: 'task-list', component: TaskListComponent, canActivate: [AuthGuard] },
	{ path: 'public-task-list', component: PublicTaskListComponent, canActivate: [AuthGuard] },


	// phone
	{ path: 'task-phone-add', component: PhoneComponent, canActivate: [AuthGuard] },
	{ path: 'task-phone-cache-edit/:taskId', component: PhoneComponent, canActivate: [AuthGuard] },
	{
		path: 'task-phone-edit/:taskId', component: PhoneComponent, canActivate: [AuthGuard], resolve: {
			taskApiResponse: TaskResolver
		}
	},
	{
		path: 'task-phone-view/:taskId', component: PhoneComponent, canActivate: [AuthGuard], resolve: {
			taskApiResponse: TaskResolver
		}
	},



	// tag
	{ path: 'tag-quick-add/:taskId', component: TagAddModalComponent, canActivate: [AuthGuard] },

	// maintenance
	{ path: 'maintenance-add', component: MaintenanceComponent, canActivate: [AuthGuard] },
	{
		path: 'maintenance-edit/:taskId', component: MaintenanceComponent, canActivate: [AuthGuard], resolve: {
			taskApiResponse: TaskResolver
		}
	},
	{
		path: 'maintenance-view/:taskId', component: MaintenanceComponent, canActivate: [AuthGuard], resolve: {
			taskApiResponse: TaskResolver
		}
	},
	{ path: 'maintenance-list', component: MaintenanceListComponent, canActivate: [AuthGuard] },
	{ path: 'compare-wiki-reservation', component: CompareWikiReservationListComponent, canActivate: [AuthGuard] },
	{ path: 'compare-reservation-ledger', component: CompareReservationLedgerListComponent, canActivate: [AuthGuard] },
	{ path: 'ru-availability-validate', component: RuAvailabilityValidateListComponent, canActivate: [AuthGuard] },
	{ path: 'check-double-booking', component: CheckDoubleBookingListComponent, canActivate: [AuthGuard] },



	// note
	{ path: 'note-add', component: NoteComponent, canActivate: [AuthGuard] },
	{ path: 'note-add/:requestData', component: NoteComponent, canActivate: [AuthGuard] },
	{ path: 'note-edit/:noteId', component: NoteComponent, canActivate: [AuthGuard] },
	{ path: 'note-view/:noteId', component: NoteComponent, canActivate: [AuthGuard] },

	// message
	{
		path: 'message-add', component: MessageComponent, canActivate: [AuthGuard], resolve: {
			messageTemplateResApi: MessageTemplateResolver
		}
	},
	{
		path: 'message-edit/:messageId', component: MessageComponent, canActivate: [AuthGuard], resolve: {
			messageTemplateResApi: MessageTemplateResolver
		}
	},
	{
		path: 'message-view/:messageId', component: MessageComponent, canActivate: [AuthGuard], resolve: {
			messageTemplateResApi: MessageTemplateResolver
		}
	},
	{ path: 'message-list', component: MessageListComponent, canActivate: [AuthGuard] },

	// messageTemplate
	{ path: 'message-template-add', component: MessageTemplateComponent, canActivate: [AuthGuard] },
	{ path: 'message-template-edit/:messageTemplateId', component: MessageTemplateComponent, canActivate: [AuthGuard] },
	{ path: 'message-template-view/:messageTemplateId', component: MessageTemplateComponent, canActivate: [AuthGuard] },
	{ path: 'message-template-list', component: MessageTemplateListComponent, canActivate: [AuthGuard] },

	{ path: 'yield-max', component: YieldMaxComponent, canActivate: [AuthGuard] },
	{ path: 'yield-max/:defaultTabIndx/:propertyId', component: YieldMaxComponent, canActivate: [AuthGuard] },
	{ path: 'yield-max/:defaultTabIndx/ext/:extSystemId', component: YieldMaxComponent, canActivate: [AuthGuard] },
	{ path: 'yield-max/:defaultTabIndx/code/:propertyCode', component: YieldMaxComponent, canActivate: [AuthGuard] },
	{ path: 'ops-dashboard', component: OpsDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'tags', component: TagListComponent, canActivate: [AuthGuard] },
	{ path: 'tracked-links', component: TrackedLinkListComponent, canActivate: [AuthGuard] },
	{ path: 'app-events', component: AppEventListComponent, canActivate: [AuthGuard] },
	{ path: 'template-analytics', component: TemplateAnalyticsComponent, canActivate: [AuthGuard] },
	{ path: 'campaign-analytics', component: CampaignAnalyticsComponent, canActivate: [AuthGuard] },
	{ path: 'help-list', component: HelpListComponent, canActivate: [AuthGuard] },
	{ path: 'quartz-jobs', component: QuartzJobListComponent, canActivate: [AuthGuard] },


  { path: 'housekeeping-reports', component: HousekeepingReportListComponent, canActivate: [AuthGuard] },

	// unified inbox — context: 7=reservations, 8=owners, 9=bizdev, 4=dev
	{ path: 'unified-inbox', redirectTo: 'unified-inbox/7', pathMatch: 'full' },
	{ path: 'unified-inbox/:context', component: UnifiedInboxComponent, canActivate: [AuthGuard] },

	// qb-sync deposit enrichment
	{ path: 'qb-sync', component: QbSyncListComponent, canActivate: [AuthGuard] },

	// drip campaigns
	{ path: 'drip-campaign-templates', component: DripCampaignTemplateListComponent, canActivate: [AuthGuard] },
	{ path: 'drip-campaign-template-edit', component: DripCampaignTemplateEditComponent, canActivate: [AuthGuard] },
	{ path: 'drip-campaign-template-edit/:id', component: DripCampaignTemplateEditComponent, canActivate: [AuthGuard] },
	{ path: 'drip-campaign-instances', component: DripCampaignInstanceListComponent, canActivate: [AuthGuard] },

	// Marketing Dashboard
	{ path: 'marketing-dashboard', component: MarketingDashboardComponent, canActivate: [AuthGuard] },

	// Phase 0 — Field Ops Platform
	{ path: 'vendors', component: VendorListComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/:id', component: VendorEditComponent, canActivate: [AuthGuard] },
	{ path: 'task-templates', component: TaskTemplateListComponent, canActivate: [AuthGuard] },
	{ path: 'task-templates/clone/:id', component: TaskTemplateEditComponent, canActivate: [AuthGuard] },
	{ path: 'task-templates/:id', component: TaskTemplateEditComponent, canActivate: [AuthGuard] },
	{ path: 'service-detail-rollup', component: ServiceDetailRollupComponent, canActivate: [AuthGuard] },

	// public, no auth
	{ path: 'styleguide', component: StyleguideComponent },
	{ path: 'admin-styleguide', component: AdminStyleguideComponent },

	// Mobile Field Ops PWA
	{ path: 'field-ops', loadChildren: () => import('./_components/field-ops/field-ops.module').then(m => m.FieldOpsModule), canActivate: [AuthGuard] },

	// otherwise redirect to home
	{ path: '**', redirectTo: '' }
];
// for debugging routes only
// export const routing = RouterModule.forRoot(appRoutes, { enableTracing: true });
export const routing = RouterModule.forRoot(appRoutes);
